import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Optional,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { PplDialogService } from '@ppl/ui/dialog';
import { VERSION, VERSION_NAME } from '@ppl/utils/injection-tokens';
import type { OnInit } from '@angular/core';
import type { PplDialogRef } from '@ppl/ui/dialog';

@Component({
    selector: 'ppl-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AboutComponent implements OnInit {

  currentDate = new Date();

  @ViewChild('content', { static: true })
  private content: TemplateRef<any>;
  private dialogRef: PplDialogRef<any>;

  constructor(
    @Optional() @Inject(VERSION) public version: string,
    @Optional() @Inject(VERSION_NAME) public versionName: string,
    private dialogService: PplDialogService,
    private router: Router,
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.dialogRef = this.dialogService.open(this.content);
      this.dialogRef.afterClosed().subscribe(() => {
        this.router.navigate(['/', { outlets: { about: null } }]);
      });
    });
  }

  close() {
    this.dialogRef.close();
  }
}
